<template>
  <v-container fluid>
    <div class="row">
      <v-col cols="12">
        <ListEmployees />
      </v-col>
    </div>
  </v-container>
</template>

<script>
import ListEmployees from '@/components/layouts/dashboard/ListEmployees'

export default {
  name: 'Home',
  components: {
    ListEmployees,
  },
}
</script>

<style lang="css" scoped>
:focus {
  outline: -webkit-focus-ring-color none !important;
}
</style>
